"use client";
import React, { Fragment } from "react";
import { Box, Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { FiArrowRight } from "@onemind-services-llc/react-icons-ng/fi";
import PageLayout from "@/layouts/pageLayout";
import { Heading, Button } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { HERO_CONSTANTS } from "./constants";
import NavigationCards from "./navigationCards";

const HeroComp = () => {
  const { title, desc, btnText } = HERO_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  return (
    <Fragment>
      <Box position="relative" minH={{ base: "440px", md: "550px" }} overflow="hidden">
        <Box position="absolute" inset="0" bg="brand.300" zIndex={-2} />
        <Box
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          overflow="hidden"
          zIndex={-1}
        >
          <video
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            aria-hidden="true"
            tabIndex={-1}
            poster="/home/home-banner-img-cmp.png"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              objectPosition: "center",
            }}
          >
            <source src="/home/home-banner-cmp.mp4" type="video/mp4" />
          </video>
        </Box>
        <Box
          position="relative"
          zIndex={1}
          color="white"
          h="100%"
          py={{ base: 8, sm: 16, md: 24 }}
        >
          <PageLayout>
            <Stack gap={8} width={{ base: "100%", md: "70%", lg: "60%", xl: "50%" }}>
              <Heading
                as="h1"
                variant={HeadingVariant}
                fontSize={{ base: "38px", md: "48px" }}
                lineHeight={{ base: "42px", md: "54px", lg: "58px" }}
                fontWeight={700}
                whiteSpace="pre-line"
              >
                {title}
              </Heading>
              <Heading as="h2" fontSize="24px" lineHeight="30px" fontWeight={550}>
                {desc}
              </Heading>
              <Button
                onClick={() => scrollToElement("contact-us", 120)}
                variant="outline"
                width="fit-content"
              >
                {btnText}
                <FiArrowRight />
              </Button>
            </Stack>
          </PageLayout>
        </Box>
      </Box>

      <PageLayout>
        <Box
          mt={{
            base: "-48vw",
            sm: "-30vw",
            md: "-25vw",
            lg: "-20vw",
            xl: "-18vw",
            "2xl": "-14vw",
            // "3xl": "-300px",
          }}
          zIndex={2}
        >
          <NavigationCards />
        </Box>
      </PageLayout>
    </Fragment>
  );
};

export default HeroComp;
